import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(cache));

export async function loadProfiles(force = false) {
  if (cache && !force) return cache;
  const { data } = await api.get("/profiles");
  cache = data;
  notify();
  return data;
}

export function upsertProfileCache(p) {
  cache = [...(cache || []).filter((x) => x.id !== p.id), p].sort((a, b) => a.name.localeCompare(b.name));
  notify();
}

export function removeProfileCache(id) {
  cache = (cache || []).filter((x) => x.id !== id);
  notify();
}

export function useProfiles() {
  const [profiles, setProfiles] = useState(cache || []);
  useEffect(() => {
    listeners.add(setProfiles);
    loadProfiles().catch(() => {});
    return () => listeners.delete(setProfiles);
  }, []);
  const refresh = useCallback(() => loadProfiles(true), []);
  return { profiles, refresh };
}

export const PROFILE_KIND_LABEL = { artist: "Artista", contributor: "Compositor / contributor", both: "Artista y compositor" };
export const DOWNTOWN_STATUS_LABEL = {
  pending: ["Pendiente en Downtown", "text-amber-500 border-amber-400/40 bg-amber-500/10"],
  in_progress: ["Creando en Downtown…", "text-blue-400 border-blue-400/40 bg-blue-500/10"],
  exists: ["Ya existía en Downtown", "text-primary border-primary/40 bg-primary/10"],
  created: ["Creado en Downtown", "text-emerald-400 border-emerald-400/40 bg-emerald-500/10"],
  error: ["Error en Downtown", "text-destructive border-destructive/40 bg-destructive/10"],
};
export const needsFullName = (kind) => kind === "contributor" || kind === "both";
